var map = {
	"./credit-card/credit-card-chip.png": "d51c",
	"./credit-card/credit-card-secure-1.png": "32e4",
	"./credit-card/credit-card-secure-2.png": "2382",
	"./credit-card/credit-card-secure-3.png": "87ec",
	"./groups/spa-attendant.svg": "5f91",
	"./groups/spa-bar.svg": "7d31",
	"./groups/spa-beautician.svg": "287f",
	"./groups/spa-cafe.svg": "f9f8",
	"./groups/spa-fitness.svg": "35d8",
	"./groups/spa-nails.svg": "9b21",
	"./groups/spa-reception.svg": "12fd",
	"./groups/spa-salon.svg": "0fdc",
	"./groups/spa-sauna.svg": "abc8",
	"./groups/spa-wellness.svg": "5c8f",
	"./groups/spa-yoga.svg": "2158",
	"./instagram/easytip-sm.png": "8a90",
	"./instagram/quotes.png": "6920",
	"./instagram/star.png": "2a78",
	"./notify/danger.svg": "d197",
	"./notify/info.svg": "608a",
	"./notify/success.svg": "80e4",
	"./notify/warning.svg": "6834",
	"./nym/nym-card-background.png": "7401",
	"./pay/pay-groups.svg": "a7cb",
	"./pay/pay-layout-1.svg": "299f",
	"./pay/pay-layout-2.svg": "6655",
	"./pay/pay-layout-3.svg": "1a55",
	"./pay/pay-room.svg": "591f",
	"./pay/pay-staff-list.svg": "784f",
	"./pay/pay-sublocations.svg": "6952",
	"./reviews/restaurant-atmosphere.svg": "d770",
	"./reviews/restaurant-bathroom.svg": "8182",
	"./reviews/restaurant-cleanliness.svg": "840c",
	"./reviews/restaurant-design.svg": "c7e5",
	"./reviews/restaurant-drinks.svg": "7a31",
	"./reviews/restaurant-food.svg": "4e51",
	"./reviews/restaurant-hookah.svg": "6a74",
	"./reviews/restaurant-location.svg": "6a4a",
	"./reviews/restaurant-music.svg": "ac19",
	"./reviews/restaurant-prices.svg": "0a95",
	"./reviews/restaurant-service.svg": "f197",
	"./reviews/restaurant-table-plan.svg": "c144",
	"./reviews/salon-atmosphere.svg": "c6e6",
	"./reviews/salon-care-products.svg": "f800",
	"./reviews/salon-cleanliness.svg": "c80c",
	"./reviews/salon-comfort.svg": "161a",
	"./reviews/salon-design.svg": "a668",
	"./reviews/salon-entertainment.svg": "a284",
	"./reviews/salon-friendliness.svg": "52ef",
	"./reviews/salon-hospitality.svg": "6b05",
	"./reviews/salon-kids-friendly.svg": "de89",
	"./reviews/salon-pet-friendly.svg": "fc08",
	"./reviews/salon-value.svg": "585b",
	"./social/facebook-color.svg": "bb77",
	"./social/facebook.svg": "2c99",
	"./social/instagram-color.svg": "97e4",
	"./social/instagram.svg": "4460",
	"./social/linkedin-color.svg": "63f1",
	"./social/linkedin.svg": "d389",
	"./social/twitter-color.svg": "5f48",
	"./social/twitter.svg": "2544",
	"./sublocations/attendant.svg": "e529",
	"./sublocations/concierge.svg": "08d1",
	"./sublocations/house-keeping.svg": "cc37",
	"./sublocations/manager.svg": "386c",
	"./sublocations/reception.svg": "55ec9",
	"./sublocations/therapist.svg": "9350",
	"./sublocations/valet.svg": "1bd2",
	"./sublocations/waiter.svg": "bfe9",
	"./welcome/onboarding-checklist.png": "e759",
	"./welcome/onboarding-completed-cut.png": "43f4",
	"./welcome/onboarding-completed-overview-uae.png": "2727",
	"./welcome/onboarding-completed-overview.png": "0e60",
	"./welcome/onboarding-completed-uae.png": "4c6a",
	"./welcome/onboarding-completed.png": "f397",
	"./welcome/welcome-1-uae.png": "6618",
	"./welcome/welcome-1.png": "a6e8",
	"./welcome/welcome-2-uae.png": "2a25",
	"./welcome/welcome-2.png": "b4a9",
	"./welcome/welcome-3.png": "6b25",
	"./welcome/welcome-4-card.png": "6520",
	"./welcome/welcome-4.png": "a18d",
	"./welcome/welcome-5.png": "0694"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b393";